import { calculateScaleFactor as n } from "@react-three/drei";
import { useFrame as s } from "@react-three/fiber";
import { memo as m, useRef as i } from "react";
import { Vector3 as a } from "three";
import { jsx as l } from "react/jsx-runtime";
const f = new a(), u = 1, w = m(function(c) {
  const o = i(null);
  return s((r) => {
    const e = o.current, t = n(e.getWorldPosition(f), u, r.camera, r.size);
    e.scale.setScalar(t);
  }), /* @__PURE__ */ l("object3D", {
    ref: o,
    ...c
  });
});
export {
  w as ScreenSizer
};
//# sourceMappingURL=index.js.map
